import { Button, Card, makeStyles } from '@material-ui/core'
import React from 'react'
import { CustomerAddress } from '../OrderSummary/types'

const useStyles = makeStyles(theme => ({
    card: {
        padding: 15,
        background: theme.palette.grey[100],
        height: '100%'
    },
    activeCard: {
        padding: 15,
        background: theme.palette.grey[100],
        border: `${theme.palette.primary.main} 2px solid`,
        height: '100%'
    }
}))

type AddressCardProps = { address: CustomerAddress, active?: boolean, onSelect: React.Dispatch<string>, selectText: string }

const AddressCard: React.FC<AddressCardProps> = ({ address, active, onSelect, selectText }) => {
    const classes = useStyles()

    return (
        <Card className={active ? classes.activeCard : classes.card}>
            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', height: '100%' }}>
                <div>
                    <p>{address.name1}</p>
                    <p>{address.street}</p>
                    <p>{address.postalCode}</p>
                    <p>{address.city}</p>
                    <p>{address.region}</p>
                    <p>{address.country}</p>
                </div>
                <div>
                    {!active && <Button onClick={() => onSelect(address.customer)} variant='contained' color='secondary' style={{ width: '100%' }}>{selectText}</Button>}
                </div>
            </div>
        </Card>
    )
}

export default AddressCard
